import React from 'react';
import completeIcon from '../imgs/response-complete-icon.svg';
import waitingIcon from '../imgs/response-waiting-icon.svg';
import acceptedIcon from '../imgs/response-accepted-icon.svg';
import errorIcon from '../imgs/error-icon.svg';

export function Block({
  img,
  headerText,
  text,
  children,
  aboveImage,
  button,
  subheader,
  redesigned,
}) {
  return (
    <section className="response">
      <div className="block text--center">
        {aboveImage}

        {img ? <img src={img} alt="" className={redesigned ? 'small_img' : ''}/> : null}
        {headerText ? <div className={`block__header ${redesigned && 'block__header__big'}`}>{headerText}</div> : null}
        {subheader && <div className="block__subheader">{subheader}</div>}
        {text ? <div className={`block__text ${!subheader && redesigned && 'block__text__smallMargin'}`}>{text}</div> : null}

        {button && (
          <button
            className="btn btn--white btn--support mw--close"
            onClick={button.onClick}
          >
            {button && 'image' in button && (
              <img
                src={button.image}
                className="block__image"
                alt="block-img"
              />
            )}
            {button && 'text' in button && button.text}
          </button>
        )}

        {children}
      </div>
    </section>
  );
}

export function ErrorBlock(props) {
  return <Block img={errorIcon} {...props} />;
}

export function SuccessBlock(props) {
  return <Block img={completeIcon} {...props} />;
}

export function WaitingBlock(props) {
  return <Block img={waitingIcon} {...props} />;
}

export function AcceptedBlock(props) {
  return <Block img={acceptedIcon} {...props} />;
}
